import script from "./SearchItemField.vue?vue&type=script&lang=ts"
export * from "./SearchItemField.vue?vue&type=script&lang=ts"

export default script